<template>
  <div class="container">
    <headerNavbar title="机构介绍"></headerNavbar>
    <!-- <van-nav-bar
      title="机构介绍"
      left-text="返回"
      right-text="按钮"
      left-arrow
      fixed
      @click-left="onClickLeft"
      @click-right="show=true"
    >
      <template #right>
        <van-icon name="ellipsis" color="#B7BBBF" style="font-weight: 600;font-size: 18px;" />
      </template>
    </van-nav-bar> -->
    <!-- <van-overlay :show="show" @click="show = false">
      <div class="popup-wrapper" @click.stop>
        <div class="popup-block" />
      </div>
    </van-overlay> -->
    <div class="wrapper">
      <div class="hosp-header">
        <div class="hosp-title">
          <h2>{{hospInfo.name}}</h2>
          <div class="logo-wrapper"></div>
        </div>
        <ul class="hosp-contact">
          <li>
            <van-icon name="location" />
            <span>{{hospInfo.address}}</span>
          </li>
          <li>
            <van-icon name="phone" />
            <span>{{hospInfo.phone}}</span>
          </li>
        </ul>
      </div>
      <div class="hosp-intro">
        <p v-html="hospInfo.introduction"></p>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
  .container {
    min-height: 100vh;
    background: #f3f3f3;

    .wrapper {
      h2 {
        font-size: 20px;
        font-weight: 500;
        line-height: 50px;
      }

      p {
        line-height: 24px;
      }

      .hosp-header {
        padding: 12px 24px;
        background: #fff;

        ul {
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 36px;

          span {
            color: rgba(0, 0, 0, 0.65);
            margin-left: 12px;
          }
        }
      }

      .hosp-intro {
        padding: 24px;
        background: #fff;
        margin-top: 12px;
      }
    }

    .popup-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }

    .popup-block {
      width: 120px;
      height: 120px;
      background-color: #fff;
    }
  }
</style>

<script>
  import Vue from "vue";
  import {
    NavBar
  } from "vant";

  Vue.use(NavBar);

  import {
    Overlay
  } from "vant";

  Vue.use(Overlay);

  import headerNavbar from '../components/headerNavbar'
  import {
    mapState,
    mapMutations,
    mapActions
  } from "vuex";
  export default {
    components: {
      headerNavbar,
    },
    data() {
      return {
        show: false,
        info: ''
      };
    },
    computed: {
      ...mapState({
        hospInfo: state => state.hospital.hospInfo
      })
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1);
      },
      onClickRight() {
        Toast("按钮");
      }
    }
  };
</script>